// extracted by mini-css-extract-plugin
module.exports = {"container":"_base-content_container_3YR8N","mainHeading":"_base-content_mainHeading_3vaeb"};